import { GridSelectionModel } from '@mui/x-data-grid-pro';
import { RowSelectionState } from '@tanstack/react-table';
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
  useMemo
} from 'react';

const actionsContext = createContext<{
  selectedUsers?: GridSelectionModel;
  setSelectedUsers: Dispatch<SetStateAction<GridSelectionModel | undefined>>;
  selectedEmployees: RowSelectionState;
  setSelectedEmployees: Dispatch<SetStateAction<RowSelectionState>>;
  bulkUpdateType?: string;
  setBulkUpdateType: Dispatch<SetStateAction<string | undefined>>;
  bulkUpdateValue?: number | string;
  setBulkUpdateValue: Dispatch<SetStateAction<number | string | undefined>>;
  bulkUpdateDate?: string;
  setBulkUpdateDate: Dispatch<SetStateAction<string | undefined>>;
} | null>(null);

export const ActionsProvider = ({ children }: PropsWithChildren) => {
  const [selectedUsers, setSelectedUsers] = useState<GridSelectionModel>();
  const [bulkUpdateType, setBulkUpdateType] = useState<string>();
  const [bulkUpdateValue, setBulkUpdateValue] = useState<number | string>();
  const [bulkUpdateDate, setBulkUpdateDate] = useState<string>();
  const [selectedEmployees, setSelectedEmployees] = useState<RowSelectionState>({});

  const value = useMemo(
    () => ({
      selectedUsers,
      setSelectedUsers,
      selectedEmployees,
      setSelectedEmployees,
      bulkUpdateType,
      setBulkUpdateType,
      bulkUpdateValue,
      setBulkUpdateValue,
      bulkUpdateDate,
      setBulkUpdateDate
    }),
    [selectedUsers, selectedEmployees, bulkUpdateType, bulkUpdateValue, bulkUpdateDate]
  );

  return <actionsContext.Provider value={value}>{children}</actionsContext.Provider>;
};

export const useActions = () => {
  const actionsStore = useContext(actionsContext);

  if (!actionsStore) {
    throw new Error('No actions store');
  }

  return actionsStore;
};
